import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import DataTableHeader from '@/components/chunks/DataTableHeader.vue';
import { useAuditStore } from '@/store/audit';
import AuditFilterResponse from '@/types/AuditFilterResponse';
import AuditItem from '@/types/interfaces/AuditItem';
import { DATE_FORMAT, PAGINATION_TABLES_NAMES, PROVIDE_KEYS } from '@/utils/constants';
import moment from 'moment';
import { inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLocale } from 'vuetify';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';

const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export default /*#__PURE__*/_defineComponent({
  __name: 'AuditTable',
  setup(__props) {

const { current } = useLocale();
const { showSnackbar }: any = inject(PROVIDE_KEYS.SNACKBAR);
const { t } = useI18n();
const auditStore = useAuditStore();
const ALL = t('TextField.All');
let filterData = ref({
  users: [] as string[],
  actions: [] as string[],
  entities: [] as string[],
  period: [] as Date[],
  selectedUser: ALL,
  selectedAction: ALL,
  selectedEntity: ALL
});

const format = (date: Date[]) => {
  const startDateString = date[0] ? moment(date[0]).format(DATE_FORMAT) : '';
  const endDateString = date[1] ? moment(date[1]).format(DATE_FORMAT) : '';
  const formattedString = `${startDateString} - ${endDateString}`;
  formattedValue.value = formattedString;
  return formattedString;
};
const formattedValue = ref();

const { handleUpdatePageSize, getTablePageSize } = useTablePaginationMixin();
const pageSize = ref(getTablePageSize(PAGINATION_TABLES_NAMES.AUDIT));

const tableData = ref([] as AuditItem[]);
auditStore.getAuditFilterParams().then((params: AuditFilterResponse) => {
  filterData.value.users = [ALL, ...params.users];
  filterData.value.actions = [ALL, ...params.actions];
  filterData.value.entities = [ALL, ...params.entities];
  search();
});

function onUpdateItemsPerPage(value: number) {
  pageSize.value = value;
  handleUpdatePageSize(PAGINATION_TABLES_NAMES.AUDIT, value);
}

function search() {
  if (filterData.value.period[0] == null || filterData.value.period[1] == null) {
    return false;
  }

  auditStore
    .searchAuditItems({
      user: filterData.value.selectedUser == ALL ? '' : filterData.value.selectedUser,
      action: filterData.value.selectedAction == ALL ? '' : filterData.value.selectedAction,
      entity: filterData.value.selectedEntity == ALL ? '' : filterData.value.selectedEntity,
      dateFrom: moment(filterData.value.period[0]).format(ISO_FORMAT),
      dateTo: moment(filterData.value.period[1]).format(ISO_FORMAT)
    })
    .then(
      (auditRows: AuditItem[]) => {
        tableData.value = auditRows;
      },
      () => {
        showSnackbar('ResponseMessage.InternalError');
      }
    );
}

const headers = [
  { title: 'TextField.Date', key: 'createdAt', width: 180 },
  { title: 'TextField.User', key: 'initiator', width: 220 },
  { title: 'TextField.Action', key: 'action', width: 50 },
  { title: 'TextField.Entity', key: 'entity', width: 50 },
  { title: 'TextField.Request', key: 'data' }
];

onMounted(() => {
  const endDate = new Date();
  const startDate = new Date(new Date().setDate(endDate.getDate() - 7));
  filterData.value.period = [startDate, endDate];
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VueDatePicker, {
              modelValue: _unref(filterData).period,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filterData).period) = $event)),
              "max-date": new Date(),
              range: "",
              format: format,
              "select-text": _ctx.$t('Calendar.Select'),
              "cancel-text": _ctx.$t('Calendar.Cancel'),
              locale: _unref(current),
              class: "small-size"
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: formattedValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formattedValue).value = $event)),
                  "hide-details": "",
                  variant: "outlined",
                  "bg-color": "input-background",
                  label: _ctx.$t('TextField.Period'),
                  color: "primary"
                }, null, 8, ["modelValue", "label"])
              ]),
              _: 1
            }, 8, ["modelValue", "max-date", "select-text", "cancel-text", "locale"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: _unref(filterData).selectedUser,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filterData).selectedUser) = $event)),
              label: _ctx.$t('TextField.User'),
              items: _unref(filterData).users,
              variant: "outlined",
              color: "primary",
              class: "small-size",
              "bg-color": "input-background"
            }, null, 8, ["modelValue", "label", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "12",
          md: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: _unref(filterData).selectedAction,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filterData).selectedAction) = $event)),
              label: _ctx.$t('TextField.Action'),
              items: _unref(filterData).actions,
              variant: "outlined",
              color: "primary",
              class: "small-size",
              "bg-color": "input-background"
            }, null, 8, ["modelValue", "label", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "12",
          md: "3",
          class: "d-inline-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: _unref(filterData).selectedEntity,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filterData).selectedEntity) = $event)),
              label: _ctx.$t('TextField.Entity'),
              items: _unref(filterData).entities,
              variant: "outlined",
              color: "primary",
              class: "small-size mr-6",
              "bg-color": "input-background"
            }, null, 8, ["modelValue", "label", "items"]),
            _createVNode(_component_v_btn, {
              class: "add-btn-small float-right",
              variant: "flat",
              icon: "mdi-magnify",
              onClick: search
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      headers: headers,
      items: tableData.value,
      "items-per-page": pageSize.value,
      class: "audit-table mt-5",
      "onUpdate:itemsPerPage": onUpdateItemsPerPage
    }, {
      headers: _withCtx(({ columns, isSorted, getSortIcon, toggleSort }) => [
        _createVNode(DataTableHeader, {
          columns: columns,
          "is-sorted": isSorted,
          "get-sort-icon": getSortIcon,
          "toggle-sort": toggleSort
        }, null, 8, ["columns", "is-sorted", "get-sort-icon", "toggle-sort"])
      ]),
      [`item.createdAt`]: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_unref(moment)((item as unknown as AuditItem).createdAt).format(_unref(DATE_FORMAT))), 1)
      ]),
      _: 2
    }, 1032, ["items", "items-per-page"])
  ], 64))
}
}

})